module.exports = __webpack_public_path__ + "static/img/1.985c265.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/1.png
// module id = gRYQ
// module chunks = 0